const TIPOS_CLIENTE = [
  {
    id: 0,
    name: 'Otros',
  },
  {
    id: 1,
    name: 'Asesoría',
  },
  {
    id: 2,
    name: 'GGCC',
  },
  {
    id: 3,
    name: 'Pyme',
  },
]

export {
  TIPOS_CLIENTE
}

